module.exports = __webpack_public_path__ + "img/paishui (2).5b902384.png";